import { useDispatch } from 'store/hooks';
import { loginAction, loginKeyAction, logoutAction } from './thunks';
import { resetLoginStateAction } from './actions';
import { useCallback } from 'react';

export const useDispatchLoginAction = () => {
    const dispatch = useDispatch();
    return (username: string, password: string) =>
        dispatch(loginAction(username, password));
};

export const useDispatchLoginKeyAction = () => {
    const dispatch = useDispatch();
    return useCallback(
        (key: string) => {
            dispatch(loginKeyAction(key));
        },
        [dispatch]
    );
};

export const useDispatchLoginResetAction = () => {
    const dispatch = useDispatch();
    return () => {
        dispatch(resetLoginStateAction());
    };
};

export const useDispatchLogoutAction = () => {
    const dispatch = useDispatch();
    return () => {
        dispatch(logoutAction());
    };
};
